import { IconSizes, PaymentIcon, useThemeClass, Text } from '@afterpaytouch/core'
import React, { FC, FunctionComponent } from 'react'
import { PaymentMethod } from './PaymentMethod'
import { PaymentMethodInfo } from './PaymentMethodInfo'
import { useTranslation } from '../../utils/convergence'
import { useApplePaylaterApplePayDisplay } from '../../state'
import clsx from 'clsx'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { isNullOrUndefined } from '@afterpay/utils'

interface Props {
  iconSize?: IconSizes
  reversed?: boolean
  showLearnMore?: boolean
  handleToggleTooltip?: () => void
  tooltipRef?: React.RefObject<HTMLElement>
  testNameSpace?: string
  validatePaymentType?: boolean
  ariaDescribedBy?: string
  disabled?: boolean
  showPaymentMethodInfo?: boolean
}

interface ApplePayTooltipProps {
  handleToggleTooltip: () => void
  ariaDescribedBy: string
}

const ApplePayTooltip: FC<ApplePayTooltipProps> = ({ handleToggleTooltip, ariaDescribedBy }) => {
  const themeClass = useThemeClass()
  const tooltipButtonClasses = clsx(styles.triggerButton, styles[themeClass])
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  return (
    <button type='button' className={tooltipButtonClasses} onClick={handleToggleTooltip} aria-describedby={ariaDescribedBy}>
      <Text size={textSize} bold renderAs='span' underline>
        {t('paymentMethod:learnMore')}
      </Text>
    </button>
  )
}

export const ApplePayPayment: FunctionComponent<Props> = ({
  iconSize,
  showLearnMore = false,
  handleToggleTooltip = () => {},
  ariaDescribedBy = '',
  disabled = false,
  showPaymentMethodInfo = false,
  ...props
}) => {
  const { t } = useTranslation()
  const { lastFour, expiryDate } = useApplePaylaterApplePayDisplay()

  return (
    <PaymentMethod
      icon={<PaymentIcon.Applepay size={iconSize} title={t('paymentMethod:applePay')} />}
      paymentMethodName={t('paymentMethod:applePay')}
      tooltip={showLearnMore && <ApplePayTooltip handleToggleTooltip={handleToggleTooltip} ariaDescribedBy={ariaDescribedBy} />}
      paymentMethodInfo={
        showPaymentMethodInfo && (!isNullOrUndefined(lastFour) || !isNullOrUndefined(expiryDate)) ? (
          <PaymentMethodInfo
            expiryDate={expiryDate}
            hasSeparator={!isNullOrUndefined(lastFour) && !isNullOrUndefined(expiryDate)}
            paymentMethodMasks={lastFour}
          />
        ) : undefined
      }
      disabled={disabled}
      {...props}
    />
  )
}
